import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component } from "react";
var RIOTBAR_SCRIPT_ID = "riotbar-script";
var RiotBarLoader = /*#__PURE__*/function (_Component) {
  _inherits(RiotBarLoader, _Component);
  var _super = _createSuper(RiotBarLoader);
  function RiotBarLoader(props) {
    _classCallCheck(this, RiotBarLoader);
    return _super.call(this, props);
  }
  _createClass(RiotBarLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // start loading
      this.loadRiotBar();
    }
  }, {
    key: "render",
    value: function render() {
      return null; // we dont actually render anything, the riotbar script does
    }
  }, {
    key: "getRiotBarUrl",
    value: function getRiotBarUrl() {
      var _this$props = this.props,
        _this$props$environme = _this$props.environment,
        environment = _this$props$environme === void 0 ? "production" : _this$props$environme,
        locale = _this$props.locale,
        product = _this$props.product;
      var version = this.props.version;
      // Default the cdnHost and environmentPath vars
      var cdnHost = "lolstatic-a.akamaihd.net";
      var environmentPath = "live";
      // If the environment is not production, reset the cdn host and environment path
      if (!["production", "prod", "live"].includes(environment)) {
        cdnHost = "cdn.rgpub.io";
        environmentPath = "test";
        // If no version was passed, and we're in a staging environment, we use master
        if (!version) {
          version = "master";
        }
        // New CDN strategy for test only
        return "https://".concat(cdnHost, "/private/").concat(environmentPath, "/riotbar/").concat(version, "/").concat(product, ".").concat(locale, ".js");
      }
      // if no version has been set, set it to latest
      if (!version) {
        version = "latest";
      }
      return "https://".concat(cdnHost, "/riotbar/").concat(environmentPath, "/").concat(version, "/").concat(product, ".").concat(locale, ".js");
    }
  }, {
    key: "loadRiotBar",
    value: function loadRiotBar() {
      if (!document.getElementById(RIOTBAR_SCRIPT_ID)) {
        var scriptEl = document.createElement("script");
        scriptEl.src = this.getRiotBarUrl();
        scriptEl.id = RIOTBAR_SCRIPT_ID;
        if (this.props.onLoad && typeof this.props.onLoad === "function") {
          var onloadFunc = this.props.onLoad;
          document.addEventListener("riotbar_onshowcomplete", function () {
            onloadFunc();
          });
        }
        if (this.props.onAuthUpdate && typeof this.props.onAuthUpdate === "function") {
          var onAuthUpdateFunc = this.props.onAuthUpdate;
          document.addEventListener("riotbar_authcheckcomplete", function () {
            onAuthUpdateFunc();
          });
        }
        document.getElementsByTagName("head")[0].appendChild(scriptEl);
      }
    }
  }]);
  return RiotBarLoader;
}(Component);
export { RiotBarLoader as default };